module.exports = __webpack_public_path__ + "static/media/2025_Arctic_Import.12c39193.png";